import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as tokens from '@trp-rps-rps-shared-web/rps-shared-web-styles';
import styled from 'styled-components';
import PopoverFooter from './PopoverFooter';

interface Props {
  position?: string;
  children: any;
  handleCancel?: () => void;
  handleDone?: () => void;
  analyticsId?: string;
  cancelId?: string;
}

const StyledPopoverCard = styled.div<{ position: undefined | string }>`
  @keyframes fadeInOpacity {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  z-index: 1;
  opacity: 1;
  animation-name: fadeInOpacity;
  animation-timing-function: ease-in-out;
  animation-duration: 0.1s;
  width: 424px;
  position: absolute;
  left: -34px;
  top: ${(props: any) => (props.position ? props.position : 'auto')};
  border-top: 4px solid #73d5ff;
  border-radius: 4px;
  box-shadow: 0 16px 16px 0 rgba(45, 57, 64, 0.06), 0 0 8px 0 rgba(45, 57, 64, 0.06);
  background-color: ${tokens.ColorWhite000};
  @media (max-width: 768px) {
    z-index: 1200;
    display: flex;
    flex-direction: column;
    width: 100vw;
    height: 100%;
    height: -webkit-fill-available;
    left: 0;
    position: fixed;
    bottom: 0;
    border-top: none;
    border-radius: 0;
  }
`;

const StyledContainer = styled.div`
  background-color: ${tokens.ColorWhite000};
  padding: 24px 32px 32px;
  max-height: 600px;
  overflow: auto;
  overflow-x: hidden;
  @media (max-width: 768px) {
    padding: 32px 16px 0;
    overflow-y: scroll;
  }
`;

class InputTilePopoverCard extends Component<Props> {
  componentDidMount() {
    document.getElementsByTagName('html')[0].classList.add('fixed');
  }

  componentWillUnmount() {
    document.getElementsByTagName('html')[0].classList.remove('fixed');
    document.getElementsByTagName('html')[0].removeAttribute('style');
  }

  render(): JSX.Element {
    const { position, children, handleCancel, handleDone, analyticsId, cancelId } = this.props;
    return (
      <StyledPopoverCard role="alert" position={position} className="input-tile-fade-in">
        <StyledContainer>{children}</StyledContainer>
        <PopoverFooter
          CTAButtonText="Done"
          handleCTAClick={handleDone}
          handleCancelClick={handleCancel}
          analyticsId={analyticsId}
          cancelId={cancelId}
        />
      </StyledPopoverCard>
    );
  }
}

export default connect(null, null)(InputTilePopoverCard);
